// Keep keyboard disclosure native; add KR's pointer flyout with a small exit grace.
const mounted = new WeakSet();
function mountShopMenus(scope = document) {
  for (const menu of scope.querySelectorAll('[data-hv-shop-submenu]')) {
    if (mounted.has(menu)) continue;
    mounted.add(menu);
    let timer;
    const groups = [...menu.querySelectorAll('details')];
    const item = menu.closest('.menu-list__list-item');
    const panel = menu.closest('.menu-list__submenu-inner');
    function measure() {
      const anchor = item?.querySelector('.menu-list__link');
      if (!anchor || !panel) return;
      const panelLeft = panel.getBoundingClientRect().left;
      const left = Math.max(16, Math.min(anchor.getBoundingClientRect().left, window.innerWidth - 320 - 16));
      menu.style.setProperty('--shop-submenu-left', `${left - panelLeft}px`);
      const height = Math.max(88, ...groups.filter(group => group.open).map(group => group.querySelector('.hv-shop-submenu__categories').scrollHeight));
      menu.style.setProperty('--shop-submenu-height', `${height}px`);
    }
    item?.addEventListener('pointerenter', measure);
    item?.addEventListener('focusin', measure);
    window.addEventListener('resize', measure);
    measure();
    for (const group of groups) {
      group.addEventListener('toggle', measure);
      group.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch') return;
        clearTimeout(timer);
        for (const sibling of groups) sibling.open = sibling === group;
        measure();
      });
    }
    menu.addEventListener('pointerenter', () => clearTimeout(timer));
    menu.addEventListener('pointerleave', () => {
      timer = setTimeout(() => {
        if (!menu.contains(document.activeElement)) for (const group of groups) group.open = false;
      }, 220);
    });
    menu.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const group = event.target.closest('details[open]');
      if (!group) return;
      event.stopPropagation();
      event.preventDefault();
      group.open = false;
      group.querySelector('summary').focus();
    });
  }
}
mountShopMenus();
document.addEventListener('shopify:section:load', (event) => mountShopMenus(event.target));

// Position only; native HeaderMenu retains hover, focus, inert and Escape ownership.
function mountFlatMenus(scope = document) {
  for (const panel of scope.querySelectorAll('.hv-flat-submenu')) {
    if (mounted.has(panel)) continue;
    mounted.add(panel);
    const item = panel.closest('.menu-list__list-item');
    const measure = () => {
      const anchor = item?.querySelector('.menu-list__link');
      if (!anchor) return;
      const left = Math.max(16, Math.min(anchor.getBoundingClientRect().left, window.innerWidth - 176));
      panel.style.setProperty('--flat-submenu-left', `${left - panel.getBoundingClientRect().left}px`);
    };
    item?.addEventListener('pointerenter', measure);
    item?.addEventListener('focusin', measure);
    window.addEventListener('resize', measure);
    measure();
  }
}
mountFlatMenus();
document.addEventListener('shopify:section:load', (event) => mountFlatMenus(event.target));
